import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-base-area-filled",
  "use": "rt-base-area-filled-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-base-area-filled\"><defs><style type=\"text/css\"></style></defs><path d=\"M883.1 346C840.4 192.7 710.2 82.4 552 65.4c-2.3-0.2-4.5-0.9-6.8-1.4h-64.6c-19.8 3.2-39.7 5.4-59.2 10.2-155.4 38-273.3 171-291.6 329.1-0.5 4.3-1.2 8.6-1.8 12.9V479c2.5 15.4 4.4 31 7.6 46.3 15.5 74.1 49.8 138.5 103.8 191.8 68.7 67.8 137.9 135 206.8 202.5 5 4.9 10.1 9.6 14.9 14.7 11 11.6 23.3 21 38.8 25.7h24.4c15.5-4.7 27.5-14.5 38.8-25.7 71.5-70.2 143-140.5 214.9-210.3 65.2-63.4 103.8-139.8 115.9-229.6 0.7-5.2 1.5-10.3 2.2-15.5v-64.5c-3.9-22.9-6.7-45.9-13-68.4zM512.3 648c-103.2 1.5-200.2-81.5-200.3-199.9 0-113.2 91.2-200.2 201.1-200.1 110.2 0.1 199.2 90.5 198.9 201.7-0.3 109.3-90.2 198.5-199.7 198.3z\" p-id=\"7286\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/area-filled.svg
// module id = 1672
// module chunks = 137